module.exports = __webpack_public_path__ + "img/instagram.eb9b686d.jpg";